import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const PATIENT_DISCOVERY_REQUEST = 'PATIENT_DISCOVERY_REQUEST';
export const PATIENT_DISCOVERY_SUCCESS = 'PATIENT_DISCOVERY_SUCCESS';
export const PATIENT_DISCOVERY_FAILURE = 'PATIENT_DISCOVERY_FAILURE';

export const DOCUMENT_QUERY_REQUEST = 'DOCUMENT_QUERY_REQUEST';
export const DOCUMENT_QUERY_SUCCESS = 'DOCUMENT_QUERY_SUCCESS';
export const DOCUMENT_QUERY_FAILURE = 'DOCUMENT_QUERY_FAILURE';

export const BILLING_GROUP_UPDATE_REQUEST = 'BILLING_GROUP_UPDATE_REQUEST';
export const BILLING_GROUP_UPDATE_SUCCESS = 'BILLING_GROUP_UPDATE_SUCCESS';
export const BILLING_GROUP_UPDATE_FAILURE = 'BILLING_GROUP_UPDATE_FAILURE';

export function requestKno2PatientDiscovery(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/kno2/patient-discovery?${query}`,
      method: 'GET',
      types: ["PATIENT_DISCOVERY_REQUEST", "PATIENT_DISCOVERY_SUCCESS", "PATIENT_DISCOVERY_FAILURE"]
    },
  };
}

export function requestKno2DocumentQuery(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/kno2/document-query?${query}`,
      method: 'GET',
      types: ["DOCUMENT_QUERY_REQUEST", "DOCUMENT_QUERY_SUCCESS", "DOCUMENT_QUERY_FAILURE"]
    }
  }
}

export function updateBillingGroup(billingGroup, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/billing-groups/${billingGroup.billingClientId}?${query}`,
      method: 'POST',
      body: JSON.stringify(billingGroup),
      types: ["BILLING_GROUP_UPDATE_REQUEST", "BILLING_GROUP_UPDATE_SUCCESS", "BILLING_GROUP_UPDATE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/query-kno2-manager/QueryKno2ManagerActions.js